import { createApiClient } from '@shared/api-client';
import type { paths } from './schema';

function getBaseUrl(): string {
  let apiDomain =
    typeof process !== 'undefined' && process.env.INTERNAL_SEARCH_API
      ? process.env.INTERNAL_SEARCH_API
      : '';
  // @ts-ignore - window check for browser vs server
  if (globalThis.window !== undefined || apiDomain === '') {
    apiDomain = `${process.env.SEARCH_API}`;
  }
  return `${apiDomain}/vto/search`;
}

export const apiClient = createApiClient<paths>({
  baseUrl: getBaseUrl(),
  label: 'Search API',
});
